<figure class="blog-block-quote">
  <blockquote>
    {{ block.text }}
  </blockquote>
  @if (block.attribution) {
    <figcaption>
      — {{ block.attribution }}
    </figcaption>
  }
</figure>
